export class NotificationTaskVariant {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
} 
